<template>
  <el-form ref="form" :model="formData" size="small" :rules="rules">
    <el-row>
      <el-form-item
        :label="$l('INDEX.form_label_production_order_doc_type') || '文档类型'"
        prop="payDocFileType"
      >
        <dict-select
          v-model="formData.payDocFileType"
          size="small"
          url="/master/common/dict/biz"
          style="width: 100%"
          filterable
          clearable
          :selectedLabel.sync="formData.v_payDocFileType"
          :body="payDocFileTypeParams"
        ></dict-select>
      </el-form-item>
    </el-row>
    <el-row class="mt-1">
      <el-upload
        drag
        action="#"
        multiple
        :file-list="listFile"
        :auto-upload="false"
        :limit="uploadLimit"
        :on-exceed="onFileExceed"
        :on-change="onFileChange"
        :on-remove="onFileChange"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
          }}<em> {{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import validate from '@/libs/util.validate'

import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    uploadLimit: { type: Number, default: 5 },
  },
  data() {
    return {
      formData: { remark: '' },
      payDocFileTypeParams: { dictType: 'payDocFileType' },
      listFile: [],
      rules: {
        payDocFileType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    onFileChange(files, fileList) {
      this.listFile = fileList
    },
    onFileExceed(files, fileList) {
      this.$message.warning(
        (this.$l('INDEX.tips_limit_selection') || '限制选择') +
          `  ${this.uploadLimit}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_selected_this_time') || '本次选择了') +
          `  ${files.length}  ` +
          (this.$l('INDEX.tips_file') || '文件') +
          ',' +
          (this.$l('INDEX.tips_a_total_of') || '共选择了') +
          `  ${files.length + fileList.length}  ` +
          this.$l('INDEX.tips_file') || '文件'
      )
    },
    async upload() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return false
      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message:
            this.$l('INDEX.tips_please_select_expense_related_documents') ||
            '请选择费用相关文档',
          type: 'warning',
        })
        return false
      }
      this.loadingOpen()
      const listDoc = await this.uploadFiles()
      this.loadingClose()
      if (!listDoc || !listDoc.length) {
        this.$message({
          message:
            this.$l('INDEX.tips_failed_to_upload_expense_related_documents') ||
            '费用相关文档上传失败',
          type: 'warning',
        })
        return false
      }

      if (listDoc.length !== listDoc.filter(Boolean).length) {
        this.$message({
          message:
            this.$l('INDEX.tips_failed_to_upload_expense_related_documents') ||
            '费用相关文档上传失败',
          type: 'warning',
        })
        return false
      }

      return { listDoc, ...this.formData }
    },
    uploadFiles() {
      if (!this.listFile || !this.listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listFile.map((file) => {
        return this.$api
          .SYS_UPLOAD(file.raw)
          .then((res) => ({
            fileCode: res.body.fileId,
            fileUrl: res.body.url,
            fileName: file.name,
          }))
          .catch(() => null)
      })
      return Promise.all(uploadTask)
    },
  },
}
</script>

<style scoped></style>
